<template>
    <div class="component_4">
      <v-data-table
        :headers="$getHeaderType1(headerTxt, headers)"
        :items="representatives"
        hide-default-footer
        disable-pagination
        class="new__type__table__view"
        mobile-breakpoint="0"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              {{ index + 1 }}
            </td>
            <td>
              <p>{{ item.name_ar }}</p>
              <p>{{ item.name_en }}</p>
            </td>
            <td>
              <p>{{ item.address_ar }}</p>
              <p>{{ item.address_en }}</p>
            </td>
            <td>
              <div class="d-flex">
                <v-btn icon @click="fnGetRepresentativesDetail(item.seq)">
                  <v-icon v-if="assign_request_type_code === '5613' && item.amend_type_code === ''">mdi-magnify</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="!item.user_seq && isRemovable" icon @click="fnDeleteRepresentativeConfirm(item.seq)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-row class="ma-0 mt-15">
        <v-col class="pa-0 d-flex" cols="12">
          <v-spacer class="d-inline-flex"></v-spacer>
          <v-btn
            dense
            outlined
            dark
            color="#a01c2a"
            width="110px"
            height="40px"
            v-show="isNewable || representatives.length === 0"
            @click="fnNewRepresentative()"
          >
            {{ $t('common.button.add') }}
          </v-btn>
        </v-col>
      </v-row>

      <RepresentativeMod
        :seq.sync="representative_seq"
        :receipt_no.sync="receipt_no"
        :isEditable="isEditable"
        :isRemovable="isRemovable"
        v-if="mod_dialog"
        @success="fnInit()"
      />

      <RepresentativeAdd
        :receipt_no.sync="receipt_no"
        :addParams.sync="addParams"
        v-if="add_dialog"
        @success="fnInit()"
      />

      <v-dialog v-model="confirm_dialog" persistent max-width="400">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text class="d-flex align-center justify-center">
            <span style="color:#000; font-size:16px!important;word-break:keep-all;">{{ (assign_request_type_code === '5613') ? $t('modification.assignchangeagent.fields.delete_representative_msg'):$t('common.message.delete.confirm.text') }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="sb_btn btn-actv" @click="fnDeleteRepresentative()">{{ $t('common.button.yes') }}</v-btn>
            <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import RepresentativeMod from './AssignChangeAgentRepresentativeMod'
import RepresentativeAdd from './AssignChangeAgentRepresentativeAdd'

export default {
  props : {
    receipt_no: String,
    isNewable: Boolean,
    isEditable: Boolean,
    isRemovable: Boolean,
    assign_request_type_code: String
  },
  components : {
    RepresentativeMod,
    RepresentativeAdd
  },
  data() {
    return {
      mod_dialog: false,
      add_dialog: false,
      confirm_dialog: false,
      representative_seq: 0,

      headerTxt : {
        prefix : 'modification.assignchangeagent.fields.',
        txt : [ '#', 'name','address','' ]
      },

      headers: [
        { text: '#', align: 'center', width: 50, sortable: false},
        { text: 'Name', align: 'center', sortable: false, width: 200 },
        { text: 'Address', align: 'center', sortable: false, },
        { text: '',  align: 'center', width: 100, sortable: false, },
      ],
      representatives: [],
      deleteRepresentativesCnt: 0,

      addParams : {
        nationality_code : '',
        residence_country_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date: '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : ''
      },

      auto_exist_yn : false
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      this.fnGetRepresentatives()
      this.fnGetRepresentativesDeleteCnt()
    },
    fnGetRepresentatives(){
      this.auto_exist_yn = false

      if(this.receipt_no != ''){
        this.representatives = []
        requestApi({
          url: '/receivings/assign/agent/'+this.receipt_no+'/representatives',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              this.representatives = res.data.list

              this.representatives.forEach(item => {
                if (!item.amend_type_code || !item.name_ar || !item.name_en || !item.address_ar || !item.address_en || !item.nationality_code || !item.residence_country_code || !item.email || !item.poa_upload_type_code) {
                  this.auto_exist_yn = true
                }
              })

              this.clearAddForm()
              this.$emit('loadRepresentatives', this.representatives)

              this.mod_dialog = false
              this.add_dialog = false
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetRepresentatives()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnGetRepresentativesDeleteCnt() {
      requestApi({
        url: '/receivings/assign/agent/'+ this.receipt_no +'/representative/delete/cnt',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.deleteRepresentativesCnt = res.data.cnt
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentativesDeleteCnt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetAddForm(){
      this.clearAddForm()
    },

    clearAddForm(){
      this.addParams.nationality_code = ''
      this.addParams.residence_country_code = ''
      this.addParams.name_ar = ''
      this.addParams.name_en = ''
      this.addParams.address_ar = ''
      this.addParams.address_en = ''
      this.addParams.pobox_ar = ''
      this.addParams.pobox_en = ''
      this.addParams.birthday_date= ''
      this.addParams.gender_type_code = ''
      this.addParams.telephone = ''
      this.addParams.mobile = ''
      this.addParams.fax = ''
      this.addParams.email = ''
    },

    //Representative 상세보기 팝업
    fnGetRepresentativesDetail(representative_seq){
      this.representative_seq = representative_seq
      this.mod_dialog = true
    },

    fnDeleteRepresentativeConfirm(representative_seq){
      this.representative_seq = representative_seq
      this.confirm_dialog = true
    },

    //Representative 삭제
    fnDeleteRepresentative(){
      requestApi({
        url: '/receivings/assign/agent/'+this.receipt_no+'/representative/'+this.representative_seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('common.message.delete.success'),
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            this.fnInit()

            this.confirm_dialog = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    //Representative 신규팝업
    fnNewRepresentative(){
      this.add_dialog = true
    }
  },
}

</script>